import { render } from "./WorkflowActionBlock.vue?vue&type=template&id=06da5daa"
import script from "./WorkflowActionBlock.vue?vue&type=script&lang=js"
export * from "./WorkflowActionBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__